import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from 'yup';
import commonFormMeta from "../commonMeta";
import { BankIDInputMeta, CorporateNameInputMeta } from '../commonMeta';

export interface IAccountRoutingRulesMeta {
  transactionCodeCheckbox: FormInputMeta
  transactionCurrencyCheckbox: FormInputMeta
  mccGroupCheckbox: FormInputMeta
  primaryAccountNumber: FormInputMeta
  applicationAID: FormInputMeta
  schema: any,
}

const AccountRoutingRulesMeta = {} as IAccountRoutingRulesMeta;

Object.assign(AccountRoutingRulesMeta, {
  transactionCodeCheckbox: commonFormMeta.transactionCodeCheckbox,
  transactionCurrencyCheckbox: commonFormMeta.transactionCurrencyCheckbox,
  mccGroupCheckbox: commonFormMeta.mccGroupCheckbox,
  bankID: BankIDInputMeta,
  corporateName: CorporateNameInputMeta,
  primaryAccountNumber: {
    name: "primaryAccountNumber",
    label: "Primary Account Number",
    type: "checkbox",
    validation: yup.boolean(),
  },
  applicationAID: {
    name: "applicationAID",
    label: "Application AID",
    type: "checkbox",
    validation: yup.boolean(),
  }
});

AccountRoutingRulesMeta.schema = yup.object().shape(getValidationSchema(AccountRoutingRulesMeta));

export default AccountRoutingRulesMeta;
